import classNames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import { CSSProperties, ReactNode, forwardRef } from 'react';

import styles from './Box.module.css';

type BoxProps = {
    vertical?: 'top' | 'middle' | 'bottom' | 'stretch';
    horizontal?:
        | 'left'
        | 'center'
        | 'right'
        | 'justify'
        | 'space-evenly'
        | 'stretch';
    wrap?: boolean;
    reverse?: boolean;
    animatePresence?: boolean;
    className?: string;
    maxWidth100Percent?: boolean;
    style?: CSSProperties;
    flex?: boolean | number | string;
    children?: ReactNode;
};

const Box = forwardRef<HTMLDivElement, BoxProps>(
    (
        {
            children,
            className,
            wrap = false,
            reverse = false,
            vertical = 'top',
            horizontal = 'left',
            maxWidth100Percent = false,
            flex = false,
            animatePresence = false,
            style = {},
        },
        ref
    ) => {
        const classes = classNames(styles.Root, className, {
            [styles.horizontalLeft]: reverse
                ? horizontal === 'right'
                : horizontal === 'left',
            [styles.horizontalCenter]: horizontal === 'center',
            [styles.horizontalRight]: reverse
                ? horizontal === 'left'
                : horizontal === 'right',
            [styles.horizontalJustify]: horizontal === 'justify',
            [styles.horizontalSpaceEvenly]: horizontal === 'space-evenly',
            [styles.horizontalStretch]: horizontal === 'stretch',
            [styles.verticalStretch]: vertical === 'stretch',
            [styles.verticalTop]: vertical === 'top',
            [styles.verticalMiddle]: vertical === 'middle',
            [styles.verticalBottom]: vertical === 'bottom',
            [styles.wrap]: wrap,
            [styles.reverse]: reverse,
            [styles.maxWidth100Percent]: maxWidth100Percent,
        });

        if (flex) {
            style.flex = flex === true ? 1 : flex;
        }

        return (
            <div className={classes} style={style} ref={ref}>
                {animatePresence ? (
                    <AnimatePresence>{children}</AnimatePresence>
                ) : (
                    children
                )}
            </div>
        );
    }
);

export default Box;
